
































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { TransitionModel, SummaryTransitionModel } from '@/models/transition';

import ListTransition from './components/ListTransition.vue';
import FilterBox from './components/FilterBox.vue';
import NewTransitionModal from './components/NewTransitionModal.vue';
import authService from '@/services/auth-services';
import transitionServices from '@/services/transition-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListTransition,
        FilterBox,
        Loading,
        Paging,
        'new-transition': NewTransitionModal
    }
})
export default class ListItem extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private summaryOrder: SummaryTransitionModel = new SummaryTransitionModel();
    private listItem: TransitionModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};
    private newTransition: any = {
        TransactionCode: ''
    };

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    private async created() {
        await this.getCustomersInfo();
        this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryTransitionModel();
        let result = await transitionServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListTransition: TransitionModel[] = [];
            this.pageSettings.total = result.data.total;

            for (const item of result.data.data) {
                const transition = new TransitionModel();
                transition.ID = item.ID;
                transition.PackageType = item.PackageType;
                transition.Status = item.Status;
                transition.TransactionCode = item.TransactionCode;
                transition.OrderID = item.OrderID;
                transition.ReceiptID = item.ReceiptID;
                transition.Weight = item.Weight;
                transition.Length = item.Length;
                transition.Width = item.Width;
                transition.Height = item.Height;
                transition.Volume = item.Volume;
                transition.FeeShipVND = item.FeeShipVND;
                transition.StoreCNImportDate = item.StoreCNImportDate;
                transition.StoreCNExportDate = item.StoreCNExportDate;
                transition.StoreVNImportDate = item.StoreVNImportDate;
                transition.StoreVNExportDate = item.StoreVNExportDate;
                transition.StoreDestImportDate = item.StoreDestImportDate;
                transition.StoreDestExportDate = item.StoreDestExportDate;
                transition.ProductName = item.ProductName;
                transition.ProductImage = item.ProductImage;
                transition.CreatedDate = item.CreatedDate;
                transition.OrderNote = item.OrderNote;
                transition.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpListTransition.push(transition);
            }
            this.listItem = tmpListTransition;
        }
        result = await transitionServices.getSummary();
        if (result && result.data && result.data.status === 200) {
            this.summaryOrder = {
                TotalStatusAll: result.data.data.TotalStatusAll || 0,
                TotalStatus0: result.data.data.TotalStatus0 || 0,
                TotalStatus1: result.data.data.TotalStatus1 || 0,
                TotalStatus2: result.data.data.TotalStatus2 || 0,
                TotalStatus3: result.data.data.TotalStatus3 || 0,
                TotalStatus4: result.data.data.TotalStatus4 || 0,
                TotalStatus5: result.data.data.TotalStatus5 || 0,
                TotalStatus6: result.data.data.TotalStatus6 || 0,
                TotalStatus7: result.data.data.TotalStatus7 || 0,
                TotalStatus8: result.data.data.TotalStatus8 || 0,
                TotalWeightAll: result.data.data.TotalWeightAll || 0,
                TotalWeight0: result.data.data.TotalWeight0 || 0,
                TotalWeight1: result.data.data.TotalWeight1 || 0,
                TotalWeight2: result.data.data.TotalWeight2 || 0,
                TotalWeight3: result.data.data.TotalWeight3 || 0,
                TotalWeight4: result.data.data.TotalWeight4 || 0,
                TotalWeight5: result.data.data.TotalWeight5 || 0,
                TotalWeight6: result.data.data.TotalWeight6 || 0,
                TotalWeight7: result.data.data.TotalWeight7 || 0,
                TotalWeight8: result.data.data.TotalWeight8 || 0,
            };
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'TransactionCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'OrderID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private createNewTransition() {
        this.isShowModal = true;
    }
    private onCloseModal() {
        this.isShowModal = false;
    }
    private async onAcceptModal() {
        if (this.newTransition.TransactionCode === '') {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Mã bill không được để trống.' });
            return;
        }
        this.isShowModal = false;
        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            TransactionCode: this.newTransition.TransactionCode,
            OrderNote: this.newTransition.OrderNote
        };
        const result = await transitionServices.addDetail(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới mã bill thành công!',
            });
            this.loadData();
            this.newTransition = {
                TransactionCode: '',
                OrderNote: ''
            };
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }
}
